import { makeStyles } from "@material-ui/core/styles";
export var useStyles = makeStyles(function (theme) { return ({
    borderNone: {
        borderWidth: "0px !important",
    },
    borderNoneFocused: {
        "&.Mui-focused fieldset": {
            borderWidth: "0px !important",
        },
    },
    button: {
        backgroundColor: "",
        borderRadius: 8,
        fontSize: "16px",
        height: "48px",
        "&.Mui-disabled": {
            backgroundColor: theme.palette.primary.main,
            color: "#FFFFFF",
        },
    },
    buttonSubtitle: {
        color: "#6D7781",
        fontSize: 14,
        fontWeight: 400,
    },
    checked: {},
    header: {
        marginTop: theme.spacing(2),
        paddingLeft: theme.spacing(2) + "px !important",
        paddingRight: theme.spacing(2) + "px !important",
    },
    infoLabel: {
        alignItems: "flex-end",
        color: "#6D7781",
        display: "flex",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "normal",
        lineHeight: "136%",
        margin: "0px 6.16573px",
        marginTop: "5px",
        paddingBottom: 8,
    },
    label: {
        color: "#293036",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "normal",
    },
    link: {
        color: "",
        fontSize: "14px",
    },
    pciIcon: {
        paddingLeft: "5px",
        paddingRight: "10px",
        position: "relative",
    },
    placeholder: {
        "& input": {
            color: "#6D7781",
        },
    },
    planBox: {
        background: "rgba(36, 63, 142, 0.1)",
        border: "1px solid #243F8E",
        borderRadius: 4,
    },
    planSubtitle: {
        color: "#243F8E",
        fontSize: 12,
        fontWeight: 400,
    },
    planTitle: {
        color: "#243F8E",
        fontSize: 20,
        fontWeight: 300,
    },
    poweredContainer: {
        fontSize: "9.24px",
        marginTop: "25px",
        textTransform: "uppercase",
    },
    poweredTitle: {
        color: "#184661",
        display: "inline",
        fontStyle: "normal",
        marginRight: "7px",
    },
    readMore: {
        color: "#6D7781",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "normal",
        paddingLeft: "5px",
        paddingRight: "10px",
        position: "relative",
    },
    spacing: {
        marginBottom: "0px",
    },
}); });
